import { modifyOrder } from "components/Apis/orders";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setShowReduxModal, updateWarehouseData } from "redux/warehouse/warehouseSlice";
import { PartialTypeRowSignal } from "../rows/partial";
import { modifyPartials } from "components/Apis/partials";
import BlankSpace from "components/UI/Atoms/BlankCell";
import { busesAPI } from "components/Apis/Buses";
import TrailerPackingPlan from "components/Buses/trailerPackingPlan/TrailerPackingPlan";

async function unloadOrders(orders) {
    for (const order of orders) {
        await modifyOrder({ id: order.id, action: "unload" })
    }
}

async function loadOrders(orders) {
    for (const order of orders) {
        await modifyOrder({ id: order.id, action: "load" })
    }
}


export const BusLoadUnloadUtility = ({ bus }) => {
    const [showModal, setShowModal] = useState(false);

    const dispatch = useDispatch()
    const direction = useSelector((state) => state.warehouse.display)
    const warehouse = useSelector((state) => state.warehouse.warehouse)

    const [packingPlan, setPackingPlan] = useState(null);
    const [loadingPackingPlan, setLoadingPackingPlan] = useState(false);

    if (direction === "Outgoing" && !packingPlan && !loadingPackingPlan) {
        setLoadingPackingPlan(true);
        busesAPI.getPackingPlan(bus.id)
            .then((data) => {
                console.log(data);
                setPackingPlan(data);
            })
            .finally(() => {
                setLoadingPackingPlan(false);
            });
    }

    return (
        <>
            {direction === "Outgoing" ? (
                <>
                    <button
                        className='btn m-1 px-2 py-1 warehouse-unload-load-button'
                        onClick={() => setShowModal(true)}
                    >
                        Load [{bus.name}]
                    </button>
                    <Modal className="warehouse-modal busModal" show={showModal} >
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm To Load</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p className="text-muted">Trailer Packing Plan</p>
                            <TrailerPackingPlan busId={bus.id} />
                            <hr />
                            <p className="text-muted">Please confirm to load the following:</p>
                            <table className='table mt-2'>
                                <thead style={{ fontWeight: "bold" }}>
                                    <tr>
                                        <th>Order Number</th>
                                        <th>Weight [lbs]</th>
                                        <th>Units</th>
                                        <th style={{ width: "5%" }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bus.partials.map((partial) => (
                                        <tr key={`partial-${partial.id}`}>
                                            <td>
                                                <div style={{ width: '100%' }} className="d-flex justify-content-left">
                                                    <div className="flex-column">
                                                        {partial.order.order_no}
                                                    </div>
                                                    <div className="flex-column">
                                                        <PartialTypeRowSignal />
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{partial.weight}</td>
                                            <td>{partial.quantity}/{partial.order.units}</td>
                                            <td>
                                                <div>
                                                    <BlankSpace />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {bus.orders.map((order) => (
                                        <tr key={`order-${order.id}`}>
                                            <td>{order.order_no}</td>
                                            <td>{order.weight}</td>
                                            <td>{order.units}</td>
                                            <td>
                                                <button
                                                    className='btn btn-primary m-1 px-2 py-1'
                                                    onClick={() => {
                                                        dispatch(
                                                            setShowReduxModal({
                                                                partialCreator: {
                                                                    orderId: order.id,
                                                                    showModal: true,
                                                                },
                                                            })
                                                        );
                                                        setShowModal(false); // This should be outside the dispatch
                                                    }}
                                                >
                                                    P
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="modal-action-button non-acting" variant="secondary" onClick={() => setShowModal(false)}>
                                Close
                            </button>
                            <button
                                className="modal-action-button decicive"
                                variant="primary"
                                onClick={() => {
                                    setShowModal(false)
                                    try {
                                        busesAPI.load(bus.id)
                                            .then(() => {
                                                dispatch(updateWarehouseData(warehouse))
                                            })
                                    }
                                    catch (error) {
                                        toast.error.error(error.response.data.msg || "Error loading bus");
                                    }
                                }}
                            >
                                Confirm
                            </button>
                        </Modal.Footer>
                    </Modal>
                </>
            ) : (
                <>
                    <button
                        className='btn m-1 px-2 py-1 warehouse-unload-load-button'
                        onClick={() => setShowModal(true)}
                    >
                        Unload
                    </button>
                    <Modal className="warehouse-modal" show={showModal} >
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm To Unload</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p className="text-muted">Trailer Packing Plan</p>
                            <TrailerPackingPlan busId={bus.id} />
                            <hr />
                            <table className='table'>
                                <thead style={{ fontWeight: "bold" }}>
                                    <tr>
                                        <th>Order Number</th>
                                        <th>Inbound</th>
                                        <th>Stop</th>
                                        <th>Weight [lbs]</th>
                                        <th>Units</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bus.partials.map((partial) => (
                                        <tr key={`partial-${partial.id}`}>
                                            <td>
                                                <div style={{ width: '100%' }} className="d-flex justify-content-left">
                                                    <div className="flex-column">
                                                        {partial.order.order_no}
                                                    </div>
                                                    <div className="flex-column">
                                                        <PartialTypeRowSignal />
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                {
                                                    partial.bus
                                                        ? <>{partial.bus.name} | {partial.bus.driver} | {partial.trailer}</>
                                                        : <>{partial.carrier} | {partial.trailer}</>
                                                }
                                            </td>
                                            <td>{partial.destination_terminal?.name}</td>
                                            <td>{partial.weight}</td>
                                            <td>{partial.quantity}/{partial.order.units}</td>
                                        </tr>
                                    ))}
                                    {bus.orders.map((order) => (
                                        <tr key={`order-${order.id}`}>
                                            <td>{order.order_no} {order.order_group} {order.backorder?.order_no}</td>
                                            <td>{order.inbound}</td>
                                            <td>{order.terminal_object?.name}</td>
                                            <td>{order.weight}</td>
                                            <td>{order.units}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="modal-action-button non-acting" variant="secondary" onClick={() => setShowModal(false)}>
                                Close
                            </button>
                            <button
                                className="modal-action-button decicive"
                                variant="primary"
                                onClick={() => {
                                    setShowModal(false)
                                    busesAPI.unload(bus.id, warehouse)
                                        .then(() => {
                                            dispatch(updateWarehouseData(warehouse))
                                        })
                                }}
                            >
                                Confirm
                            </button>
                        </Modal.Footer>
                    </Modal>
                </>
            )
            }
        </>
    )
}


export const OrderLoadUnloadUtility = ({ order }) => {
    const [showModal, setShowModal] = useState(false);

    const dispatch = useDispatch()
    const direction = useSelector((state) => state.warehouse.display)
    const warehouse = useSelector((state) => state.warehouse.warehouse)


    return (
        <>
            {direction === "Outgoing" ? (
                <>
                    <button
                        className='btn m-1 px-2 py-1 warehouse-unload-load-button'
                        onClick={() => setShowModal(true)}
                        disabled={order.unloaded != 1}
                    >
                        L
                    </button>
                    <Modal className="warehouse-modal" show={showModal} >
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm To Load</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <table className='table'>
                                <thead style={{ fontWeight: "bold" }}>
                                    <tr>
                                        <th>Order Number</th>
                                        <th>Weight [lbs]</th>
                                        <th>Units</th>
                                        <th style={{ width: "5%" }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[order].map((order) => (
                                        <tr key={`order-${order.id}`}>
                                            <td>{order.order_no} {order.order_group} {order.backorder?.order_no}</td>
                                            <td>{order.weight}</td>
                                            <td>{order.units}</td>
                                            <td>
                                                <button
                                                    className='btn btn-primary m-1 px-2 py-1'
                                                    onClick={() => {
                                                        dispatch(
                                                            setShowReduxModal({
                                                                partialCreator: {
                                                                    orderId: order.id,
                                                                    showModal: true,
                                                                },
                                                            })
                                                        );
                                                        setShowModal(false); // This should be outside the dispatch
                                                    }}
                                                >
                                                    P
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="modal-action-button non-acting" variant="secondary" onClick={() => setShowModal(false)}>
                                Close
                            </button>
                            <button
                                className="modal-action-button decicive"
                                variant="primary"
                                onClick={() => {
                                    loadOrders([order])
                                        .then(
                                            () => {
                                                setShowModal(false)
                                                dispatch(updateWarehouseData(warehouse))
                                            }
                                        )
                                }}
                            >
                                Confirm
                            </button>
                        </Modal.Footer>
                    </Modal>
                </>
            ) : (
                <>
                    <button
                        className='btn m-1 px-2 py-1 warehouse-unload-load-button'
                        onClick={() => setShowModal(true)}
                    >
                        Unload
                    </button>
                    <Modal className="warehouse-modal" show={showModal} >
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm To Unload</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <table className='table'>
                                <thead style={{ fontWeight: "bold" }}>
                                    <tr>
                                        <th>Order Number</th>
                                        <th>Inbound</th>
                                        <th>Weight [lbs]</th>
                                        <th>Units</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[order].map((order) => (
                                        <tr key={order.id}>
                                            <td>{order.order_no} {order.order_group} {order.backorder?.order_no}</td>
                                            <td>{order.inbound}</td>
                                            <td>{order.weight}</td>
                                            <td>{order.units}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="modal-action-button non-acting" variant="secondary" onClick={() => setShowModal(false)}>
                                Close
                            </button>
                            <button
                                className="modal-action-button decicive"
                                variant="primary"
                                onClick={() => {
                                    unloadOrders([order])
                                        .then(
                                            () => {
                                                setShowModal(false)
                                                dispatch(updateWarehouseData(warehouse))
                                            }
                                        )
                                }}
                            >
                                Confirm
                            </button>
                        </Modal.Footer>
                    </Modal>
                </>
            )
            }
        </>
    )
}

export const PartialLoadConfirmation = ({ partial }) => {
    const dispatch = useDispatch()

    const warehouse = useSelector((state) => state.warehouse.warehouse)

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const openModal = (partial) => {
        setShowConfirmationModal(true);
    }

    const closeModal = () => {
        setShowConfirmationModal(false);
    }

    return (
        <>
            {(partial.incoming_completed) ? (
                <button
                    className='btn bg-primary m-1 px-2 py-1 warehouse-unload-load-button'
                    onClick={() => openModal(partial)}>
                    Received
                </button>

            ) : (
                <button
                    className='btn btn-danger m-1 px-2 py-1 warehouse-unload-load-button'
                    onClick={() => openModal(partial)}>
                    Not Received
                </button>
            )
            }

            <Modal show={showConfirmationModal} onHide={closeModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Load Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Are you sure you want to load this partial?
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => {
                        modifyPartials({ id: partial.id, action: "unload" })
                        closeModal()
                        setTimeout(() => {
                            dispatch(updateWarehouseData(warehouse))
                        }, 500)
                    }}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
